module.exports = "<p class=\"control has-addons flatpickr\" data-wrap=true data-clickopens=false :class=\"{ [`has-addons-${alignment}`]: alignment }\"> <input class=input type=text :placeholder=placeholder :readonly=readonly v-model=value data-input/> <slot></slot> </p> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-bulma-datepicker/src/wrapperInput.html
// module id = 791
// module chunks = 2